module.exports = __webpack_public_path__ + "static/raj-by-rupy-d2d4d8e4d8c852bf532fd5580949fa26.png";